import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 22px;
  height: 24px;
  margin-right: 0.5rem;
`;

const CapacityIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
        <path d="M11 8.97c-3.3 0-8.35-.52-11-2.25v2.44c0 1.92 5.12 3.49 11 3.49s11-1.57 11-3.5V6.73c-2.66 1.74-7.7 2.25-11 2.25zM11 0C5.12 0 0 1.56 0 3.49s5.12 3.48 11 3.48S22 5.41 22 3.5 16.88 0 11 0zm0 14.65c-3.3 0-8.35-.53-11-2.26v2.43c0 1.93 5.12 3.5 11 3.5s11-1.57 11-3.5V12.4c-2.66 1.74-7.7 2.26-11 2.26zm11 3.4v2.46C22 22.44 16.88 24 11 24S0 22.44 0 20.5v-2.46c2.66 1.74 7.7 2.26 11 2.26s8.35-.52 11-2.25z" fill="#4694ce" />
    </Svg>
  );
};

export default CapacityIcon;
